import { CoreState } from "../state";

import { AlternativeCultureUrl, DocumentMetaState, SeoContent } from "./document-meta.model";

export namespace DocumentMetaSelector {
	export const getState = (state: CoreState): DocumentMetaState => state.documentMeta;

	export const getCanonicalUrl = (state: CoreState): string | undefined => state.documentMeta.canonicalUrl;

	export const getMetaDescription = (state: CoreState): string | undefined => state.documentMeta.metaDescription;

	export const getMetaTitle = (state: CoreState): string | undefined => state.documentMeta.metaTitle;

	export const getAlternativeUrls = (state: CoreState): AlternativeCultureUrl[] | undefined =>
		state.documentMeta.alternativeUrls;

	export const getSeoContent = (state: CoreState): SeoContent | undefined => state.documentMeta.seoContent;
}
